
export const adminUrl=import.meta.env.VITE_ADMIN_URL
export const userUrl=import.meta.env.VITE_USER_URL
export const theatreUrl=import.meta.env.VITE_THEATRE_URL
export const mapBoxToken=import.meta.env.VITE_MAPBOX_TOKEN
export const tmdbApiKey='de211859fbf9be075be8898c50affa35'
